import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import shallowequal from 'shallowequal';
var propTypes = {
  record: PropTypes.object,
  clsPrefix: PropTypes.string,
  expandable: PropTypes.any,
  expanded: PropTypes.bool,
  needIndentSpaced: PropTypes.bool,
  onExpand: PropTypes.func
};

var ExpandIcon = /*#__PURE__*/function (_Component) {
  _inherits(ExpandIcon, _Component);

  var _super = _createSuper(ExpandIcon);

  function ExpandIcon(props) {
    var _this;

    _classCallCheck(this, ExpandIcon);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onExpand", function (status, record, e) {
      var onExpand = _this.props.onExpand;
      e.stopPropagation();
      onExpand(status, record, e);
    });

    return _this;
  }

  _createClass(ExpandIcon, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !shallowequal(nextProps, this.props);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          expandable = _this$props.expandable,
          clsPrefix = _this$props.clsPrefix,
          onExpand = _this$props.onExpand,
          needIndentSpaced = _this$props.needIndentSpaced,
          expanded = _this$props.expanded,
          record = _this$props.record,
          isHiddenExpandIcon = _this$props.isHiddenExpandIcon,
          expandedIcon = _this$props.expandedIcon,
          collapsedIcon = _this$props.collapsedIcon;

      if (expandable && !isHiddenExpandIcon) {
        var expandClassName = expanded ? 'expanded' : 'collapsed';
        var currentIcon = /*#__PURE__*/React.createElement("span", {
          className: "".concat(clsPrefix, "-expand-icon ").concat(clsPrefix, "-").concat(expandClassName)
        });

        if (expanded && expandedIcon) {
          currentIcon = expandedIcon;
        } else if (!expanded && collapsedIcon) {
          currentIcon = collapsedIcon;
        }

        return /*#__PURE__*/React.createElement("span", {
          onClick: function onClick(e) {
            return _this2.onExpand(!expanded, record, e);
          },
          className: "expand-icon-con"
        }, currentIcon);
      } else if (needIndentSpaced || isHiddenExpandIcon) {
        return /*#__PURE__*/React.createElement("span", {
          className: "".concat(clsPrefix, "-expand-icon ").concat(clsPrefix, "-spaced")
        });
      }

      return null;
    }
  }]);

  return ExpandIcon;
}(Component);

;
ExpandIcon.propTypes = propTypes;
export default ExpandIcon;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-table/src/ExpandIcon.js